export const COMPANY = {
  name: "Auto Socorro Ventania",
  fullName: "Auto Socorro Ventania Ribeirão Preto",
  phoneDisplay: "(16) 99332-1659",
  phoneLink: "5516993321659",
  phoneTel: "+5516993321659",
  whatsappMessage:
    "Olá! Preciso de um guincho agora em Ribeirão Preto. Pode me ajudar?",
  address:
    "Rua Delfon e Luiza Bressan, nº 440 — Condomínio Reserva Imperial, Ribeirão Preto/SP",
  city: "Ribeirão Preto",
  region: "SP",
  instagram: "https://www.instagram.com/autosocorroventania",
  instagramHandle: "@autosocorroventania",
  facebook: "https://www.facebook.com/share/1Je5CgUrH7/",
  facebookHandle: "Auto Socorro Ventania",
};

export const waLink = (msg) =>
  `https://wa.me/${COMPANY.phoneLink}?text=${encodeURIComponent(
    msg || COMPANY.whatsappMessage,
  )}`;

export const MEDIA = {
  logo: "https://customer-assets.emergentagent.com/job_1517d037-277d-492a-a8b7-d118978ab90a/artifacts/m46bxzv0_WhatsApp_Image_2026-05-07_at_06.23.26-removebg-preview.png",
  truck1:
    "https://customer-assets.emergentagent.com/job_1517d037-277d-492a-a8b7-d118978ab90a/artifacts/n7h4b9ze_WhatsApp%20Image%202026-05-06%20at%2014.16.45-2.jpeg",
  truck2:
    "https://customer-assets.emergentagent.com/job_1517d037-277d-492a-a8b7-d118978ab90a/artifacts/tbl7g3fp_WhatsApp%20Image%202026-05-06%20at%2014.16.44.jpeg",
  truck3:
    "https://customer-assets.emergentagent.com/job_1517d037-277d-492a-a8b7-d118978ab90a/artifacts/rrhatwyu_WhatsApp%20Image%202026-05-06%20at%2014.16.44-2.jpeg",
  truck4:
    "https://customer-assets.emergentagent.com/job_1517d037-277d-492a-a8b7-d118978ab90a/artifacts/cf27icdw_WhatsApp%20Image%202026-05-06%20at%2014.18.07.jpeg",
};
